import React from "react";
import { Eye, Pencil, Trash2 } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Recipient Type list. Edit and Delete are Super Admin only (`canManage`).
export default function RecipientTypeRowActions({ row, canManage, onView, onEdit, onDelete }) {
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} />
      {canManage && (
        <>
          <IconAction label="Edit" icon={Pencil} tone="primary" onClick={() => onEdit(row)} />
          <IconAction label="Delete" icon={Trash2} tone="danger" onClick={() => onDelete(row)} />
        </>
      )}
    </div>
  );
}
